<template>
  <v-card
    v-if="data != null"
    elevation="1"
    class="rounded-lg d-flex flex-column full-width pgm-dashboard-container progress-container text-left"
    :ripple="false"
    :class="{ 'pa-4': !isMobile, 'pa-2': isMobile }"
  >
    <div class="d-flex justify-space-between align-center full-width mb-3">
      <h3 class="work-break mt-1 text-left">{{ $t("dashboardWidgets.progress.title") }}</h3>
    </div>
    <span v-if="config?.title?.text" class="rule-text" :style="titleTextStyle">{{
      config?.title?.text
    }}</span>
    <span v-if="config?.description?.text" class="mt-2 rule-text" :style="descriptionTextStyle">{{
      config?.description?.text
    }}</span>
    <v-progress-linear
      v-if="WidgetData?.goal"
      :value="WidgetData?.progressPercent"
      :color="config?.bar?.color || 'brandCyan'"
      height="20"
      class="full-width rounded-xl mt-5"
    ></v-progress-linear>
    <div class="text-center mt-2 rule-text">
      {{ WidgetData?.progress }} / {{ WidgetData?.goal }}
    </div>
  </v-card>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "Progress",
  props: {
    config: {
      type: Object,
      required: true,

      // Developer note:
      // This schema is for readability - it doesn't actually restrict anything on the Vue side
      title: {
        type: Object,
        required: false,
        text: {
          type: String,
          required: true,
        },
        color: {
          type: String,
          required: false,
          default: "black",
        },
      },
      description: {
        type: Object,
        required: false,
        text: {
          type: String,
          required: true,
        },
        color: {
          type: String,
          required: false,
          default: "black",
        },
      },
    },
    widgetData: {
      type: Object,
      required: false,
      default: null,
      goal: {
        type: Number,
        required: true,
      },
      progress: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    previewMode: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    ...mapState([]),
    titleTextStyle() {
      let style = {
        color: this.config?.title?.color || "black",
        // "font-weight": this.config?.title?.weight || "normal"
      };

      return style;
    },
    descriptionTextStyle() {
      let style = {
        color: this.config?.description?.color || "black",
        // "font-weight": this.config?.description?.weight || "bold"
      };

      return style;
    },
    WidgetData() {
      if (this.previewMode) return { goal: 10, progressPercent: 20, progress: 2 };
      return this.data || this.widgetData || {};
    },
  },
};
</script>
<style scoped>
.progress-container {
  width: 100%;
  height: auto;
}

/* Removes the grey shadow when clicking a card */
.v-card--link:before {
  background: none;
}

.rule-text {
  font-size: 0.75em;
}
</style>
